import React, { Component } from 'react';
// import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import LoadingBar from 'react-redux-loading-bar';
import InfoBox from '../components/InfoBox/index.js';
// import { showInfoBox, hideInfoBox } from "../components/InfoBox/index.js";


import Sidebar from './components/Sidebar/index.js';

import PortletsPage from './portlets/index.js';
import PortletCreatePage from './portlet_create/index.js';
import PortletUpdatePage from './portlet_update/index.js';

import './index.css';
class RootPage extends Component {
  render() {
    return (
      <div>
        <LoadingBar
          progressIncrease={5}
          updateTime={100}
          style={{ backgroundColor: 'rgb(0, 177, 217)', height: '5px', position: 'fixed', zIndex: 150 }}
        />

        <InfoBox />

        <Sidebar />

        <div className="mainbar_wrapper">

          <div className="content_wrapper">
            <Switch>
              <Route exact path="/" render={() => (
                <Redirect to="/portlets" />
              )} />

              <Route exact path='/portlets' component={PortletsPage} />
              <Route exact path='/portlets/create' component={PortletCreatePage} />
              <Route exact path='/portlets/update' component={PortletUpdatePage} />
            </Switch>
          </div>

        </div>

      </div >
    );
  }
}



export default RootPage;


// WEBPACK FOOTER //
// ./src/routes/index.js